import { useState } from 'react';

// material ui
import { Box, Tab } from '@mui/material';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';

// helpers
import { formatNumber } from '@/shared/constants';

// graphql
import { usePawGetChipsSummaryQuery, useCashierProfileQuery } from '@/generated/graphql';

// components
import { TerminalLossTransfer } from './components/terminal-loss-transfer/terminal-loss-transfer';
import { TerminalProfitWithdrawal } from './components/terminal-profit-withdrawal/terminal-profit-withdrawal';
import { CashChipsSummary } from './components/cash-chips-summary/cash-chips-summary';

export const ProfitLossTransactionPage = () => {
  const [tabValue, setTabValue] = useState('1');

  const [cashBalance, setCashBalance] = useState('0');
  const [chipsBalance, setChipsBalance] = useState('0');

  const pawGetChipsSummaryQuery = usePawGetChipsSummaryQuery({
    notifyOnNetworkStatusChange: true,
    onCompleted(data) {
      setTimeout(() => {
        setChipsBalance(formatNumber(data.chipsSummary?.cashiersChips));
      }, 100);
    },
  });

  const cashierProfileQuery = useCashierProfileQuery({
    notifyOnNetworkStatusChange: true,
    onCompleted(data) {
      setTimeout(() => {
        setCashBalance(formatNumber(data.cashierProfile?.cashBalance));
      }, 100);
    },
  });

  const refetch = () => {
    pawGetChipsSummaryQuery.refetch();
    cashierProfileQuery.refetch();
  };

  const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
    setTabValue(newValue);
  };

  return (
    <>
      <CashChipsSummary cashBalance={cashBalance} chipsBalance={chipsBalance} />
      <Box sx={{ width: '100%', typography: 'body1', ml: 1 }}>
        <TabContext value={tabValue}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <TabList onChange={handleTabChange} aria-label="lab API tabs example">
              <Tab label="Profit Withdrawals" value="1" />
              <Tab label="Loss Transfers" value="2" />
            </TabList>
          </Box>
          <TabPanel value="1" style={{ padding: '0em' }}>
            <TerminalProfitWithdrawal refetch={refetch} />
          </TabPanel>
          <TabPanel value="2" style={{ padding: '0em' }}>
            <TerminalLossTransfer refetch={refetch} />
          </TabPanel>
        </TabContext>
      </Box>
    </>
  );
};
